import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* 工作台功能开关：置为 true 可恢复 /workbench 页面（导航入口开关见 Header.vue 的 showWorkbench） */
const SHOW_WORKBENCH = false

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: 'open_platform'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: 'open_platform'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: 'open_platform'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: 'open_platform'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: 'open_platform'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: 'open_platform'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: 'open_platform'
          }
        }, {
          path: '/document',
          name: 'document',
          component: resolve => require(['@/view/Document'], resolve),
          meta: {
            title: 'open_platform'
          }
        }, {
          path: '/doc/:module',
          name: 'docCenter',
          component: resolve => require(['@/view/DocCenter'], resolve),
          meta: {
            title: 'document_center'
          }
        }, {
          path: '/doc/:module/:slug',
          name: 'docCenterDoc',
          component: resolve => require(['@/view/DocCenter'], resolve),
          meta: {
            title: 'document_center'
          }
        }, {
          path: '/register',
          name: 'register',
          component: resolve => require(['@/view/Register'], resolve),
          meta: {
            title: 'open_platform'
          }
        }, {
          path: '/login',
          name: 'login',
          component: resolve => require(['@/view/Login'], resolve),
          meta: {
            title: 'open_platform'
          }
        }, {
          path: '/usermsg',
          name: 'usermsg',
          component: resolve => require(['@/view/UserMsg'], resolve),
          meta: {
            title: 'open_platform'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: 'open_platform'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: 'open_platform'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: 'open_platform'
          }
        },
        {
          path: '/CompanyInfo',
          name: 'CompanyInfo',
          component: resolve => require(['@/view/CompanyInfo'], resolve),
          meta: {
            title: 'open_platform'
          }
        },
        {
          path: '/InterfaceDoc',
          name: 'InterfaceDoc',
          component: resolve => require(['@/view/InterfaceDoc'], resolve),
          meta: {
            title: 'open_platform'
          }
        },
        {
          path: '/TicketClients',
          name: 'TicketClients',
          component: resolve => require(['@/view/TicketClients'], resolve),
          meta: {
            title: 'open_platform'
          }
        },
        {
          path: '/Ticket',
          name: 'Ticket',
          component: resolve => require(['@/view/Ticket'], resolve),
          meta: {
            title: 'open_platform'
          }
        },
        {
          path: '/WifiDemo',
          name: 'WifiDemo',
          component: resolve => require(['@/view/WifiDemo'], resolve),
          meta: {
            title: 'open_platform'
          }
        },
        {
          path: '/workbench',
          name: 'Workbench',
          component: resolve => require(['@/view/Workbench'], resolve),
          beforeEnter: (to, from, next) => {
            /* 功能关闭时禁止直达，重定向回首页 */
            if (!SHOW_WORKBENCH) {
              next('/home')
            } else {
              next()
            }
          },
          meta: {
            title: 'open_platform'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js